// 折扣小数点问题处理
const handleDiscount = (data) => {
  typeof data == "number" && (data = (data * 100) / 10);

  //   console.log("折扣信息----------------", data);
  return data;
};

// 复制函数
import Clipboard from "clipboard";
import { Toast } from "vant";

const handleCopy = (name, data) => {
  // console.log("复制的内容",name, data);
  let clipboard = new Clipboard(name, {
    text: () => {
      //返回需要复制的字符串，去掉头尾的"
      return JSON.stringify(data).replace(/^"|"$/g, "");
    },
  });
  clipboard.on("success", (e) => {
    clipboard.destroy();
    // Toast("邀请地址已复制，快分享给好友吧～");
    Toast("复制成功～");
  });
  clipboard.on("error", (e) => {
    // console.log(e);
    Toast("您的浏览器不支持点击复制");
    clipboard.destroy();
  });
};

// 保存图片函数
const handleSaveImg = (url) => {
  console.log("保存图片", url);
  // 将img转为blob
  fetch(url)
    .then((res) => res.blob())
    .then((blob) => {
      const a = document.createElement("a");
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = "图片";
      a.click();
      window.URL.revokeObjectURL(url);
    });
};
export { handleDiscount, handleCopy, handleSaveImg };
